import { AxiosResponse } from "axios";
import { call, put } from "redux-saga/effects";
import api from "../../Axios/middleware";

import { PayloadAction } from "@reduxjs/toolkit";
import { IReExamPracticelistID } from "../../../Pages/Exam/IExam";
import {
  failurelistReExamPracticeID,
  successlistReExamPracticeID,
} from "./ListReExamPracticeSlice";

// list exam id

const ListReExamPracticeIDApi = (
  action: PayloadAction<IReExamPracticelistID>
) => {
  console.log(action.payload);

  return api.get("/api/exam/retaketest", { params: action.payload });
};

export function* ListReExamPracticeIDCall(
  action: PayloadAction<IReExamPracticelistID>
) {
  try {
    const response: AxiosResponse = yield call(ListReExamPracticeIDApi, action);
    yield put(successlistReExamPracticeID(response.data));
  } catch (error) {
    yield put(failurelistReExamPracticeID(error));
  }
}
